<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div :class="bodyClassName + ' transportation-route-list tabulator-parent'">
      <div class="row">
        <div class="col-md-12">
          <h3><i class="fa fa-fw fa-tag"></i> {{ _('Routes') }}</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 col-sm-4 filtercol">
          <div class="form-group">
            <div class="input-group">
              <input class="form-control" id="searchField" type="text" v-model="search" :placeholder="_('Keyword search')" />
              <span class="input-group-btn">
                <button type="button" class="btn btn-success"><i class="fa fa-fw fa-search"></i></button>
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-9 col-sm-8 filtercol newbuttoncol">
          <button class="pull-right newSelector btn btn-success addbutton" type="button" v-on:click="createNewDialog"><i class="fa fa-fw fa-plus"></i> {{ _('New route') }}</button>
        </div>
      </div>	
      <Datatable :url="transportationRoutesUrl" :search="search" :options="tableOptions" ref="datatableTransportationRoutes" v-on:data="tableEvent" />
    </div>
    <nav class="modal-footer button-row" v-if="isModal">
      <div class="to-right">
        <button class="btn btn-default" v-on:click="close"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      </div>
    </nav>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import formatters from '~/lib/formatters'
import { Datatable, ModalTransportationRouteDetails as TransportationRouteDetails} from '#components'
import debounce from 'lodash/debounce'

export default {
  data () {
    const $this = this
    const _ = useNuxtApp().$translate
    return {
      search: '',
      tableOptions: {
        columns: [
        {
          title: 'ID',
          field: 'id',
          width: 70,
          responsive: 0
        },
        {
          title: _('Name'),
          field: 'name',
          widthGrow: 4,
          responsive: 0
        },
        ],
        initialSort: [{
          column: 'name',
          dir: 'asc'
        }],
        rowClick (e, row) {
          const id = row.getCell('id').getValue()
          const name = row.getCell('name').getValue()
          $this.editTransportationRoute(id, name)
        }
      }
    }
  },
  mixins: [components, formatters],
  computed: {
    transportationRoutesUrl () {
      return this.baseDomain + this.shopId + '/routes.json?apikey=' + this.apiKey
    }
  },
  methods: {
    createNewDialog () {
      this.showDialog({
        title: this._('New route'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'save',
            requiredFields: ['name'],
            handler: (data) => {
              this.createNew(data)
            }
          }
        ],
        fields: [
          {
            title: this._('Name'),
            type: 'text',
            name: 'name'
          }
        ]
      })
    },
    async createNew (data) {
      let response
      const d = {
        name: data.name,
      }
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/routes.json?apikey=' + this.apiKey, d)
      } catch(e) {
        this.showError(e)
        return
      }
      this.editTransportationRoute(response.data, data.name)
    },
    editTransportationRoute (id, name) {
      if (this.isModal) {
        this.showModal('transportationroutedetails', TransportationRouteDetails, {
          props: {
            baseDomain: this.baseDomain,
            shopId: this.shopId,
            apiKey: this.apiKey,
            component: {
              type: 'TransportationRouteDetails',
              initData: {
                routeId: id,
                modal: true
              }
            },
            className: 'modal-content'
          },
          events: {},
          handlers: {},
          width: 1000
        })
      } else {
        this.EventBus.$emit('showDetailsColumn', {
          shopId: this.shopId,
          component: 'TransportationRouteDetails',
          title: this._('Route') + ' ' + id + ': ' + name,
          width: 6,
          data: {
            routeId: id
          }
        })
      }
    },
    reload () {
      if (this.$refs && this.$refs.datatableTransportationRoutes) {
        this.$refs.datatableTransportationRoutes.reload()
      }
    }
  },
  components: {
    Datatable
  },
  mounted () {
    if(!this.events) {
      let events = {}
      events['routeUpdate'] = debounce((message) => {
        return this.reload()
      }, 200)
      this.events = events
    }
    this.enableEventBus()
  }
}
</script>